import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Thankyou() {
    const navigate = useNavigate();

    useEffect(() => {
        // Google Ads Conversion
        if (window.gtag) {
            window.gtag('event', 'conversion', {
                send_to: 'AW-18148644562/EufQCLDXwqkcENKt-c1D',
                value: 1.0,
                currency: 'INR',
            });

            console.log("Google Conversion Fired");
        }

        // Redirect
        const timer = setTimeout(() => {
            navigate("/");
        }, 3000);

        return () => clearTimeout(timer);

    }, [navigate]);

  return (
    <>
    <div className="thankyou-page">
        <div className="thankpage-box">
            <div className="thankbox">
                <img src="/image/thankyou.webp" className="img-responsive" alt="Thankyou"/>
                <p>I hope these ideas inspire you to reimagine your spaces… Share your transformations and remember, a well-designed home always reflects your story.</p>
            </div>
        </div>
    </div>
    </>
  )
}
